import styled from 'styled-components'
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden !important;
  padding-top: 100px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    overflow: scroll;
    padding-top: 10px;
  }
  .back {
    padding: 50px 100px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: ${({ theme }) => theme.colors.secondPrimary};
    cursor: pointer;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 50px 30px;
    }
  }
`

export const ForgotWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -100px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-top: -50px;
  }
  .welcome {
    text-align: center;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      text-align: left;
      align-self: flex-start;
      padding-left: 40px;
    }

    h1 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      letter-spacing: 0.2px;
      color: #333333;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 24px;
      }
    }
    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: ${({ theme }) => theme.colors.CardDark};
      margin-bottom: 50px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        margin-top: -10px;
        margin-bottom: 40px;
        font-size: 14px;
      }
    }
  }
`

export const FormWrapper = styled.form`
  width: 35%;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 80%;
    margin-bottom: 300px;
  }
  .each-form {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .to-left {
      float: right;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.secondPrimary};
    }
  }
  .revert {
    margin-top: -20px;
  }
  label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
    padding-bottom: 10px;
  }
`
